import styles from "./AttendanceForecast.module.css";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  {
    _id: "1",
    program: "Program 1",
    expected: 1,
    checkedIn: 1,
    checkedOut: 2,
    absent: 2,
  },
  {
    _id: "2",
    program: "Program 1",
    expected: 1,
    checkedIn: 1,
    checkedOut: 2,
    absent: 2,
  },
  {
    _id: "3",
    program: "Program 1",
    expected: 1,
    checkedIn: 1,
    checkedOut: 2,
    absent: 2,
  },
  {
    _id: "4",
    program: "Program 1",
    expected: 1,
    checkedIn: 1,
    checkedOut: 2,
    absent: 2,
  },
];

function AttendanceForecast() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const getColumnData = (data) => {
    return data?.map((item) => ({
      program: (
        <span style={{ color: "var(--Primary_Color)", fontWeight: 400 }}>
          {item.program}
        </span>
      ),
      expected: item.expected.toString().padStart(2, "0"),
      checkedIn: item.checkedIn.toString().padStart(2, "0"),
      checkedOut: item.checkedOut.toString().padStart(2, "0"),
      absent: item.absent.toString().padStart(2, "0"),
    }));
  };

  const displayData = getColumnData(data);

  const headingsData = [
    { title: "Program", accessor: "program" },
    { title: "Expected", accessor: "expected" },
    { title: "Checked In", accessor: "checkedIn" },
    { title: "Checked out", accessor: "checkedOut" },
    { title: "Absent", accessor: "absent" },
  ];

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerContainer} style={{ padding: "1rem" }}>
          <h4
            style={{
              color: "var(--Primary_Color)",
              fontWeight: "400",
              marginBottom: "1.5rem",
            }}
          >
            Attendance Forecast
          </h4>

          <div className={styles.totalstudentcard}>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
              <div className={styles.paginationTable}>
                <PaginationTable
                  data={displayData}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
       
         
        
      </div>
      <CopyRight />
    </>
  );
}

export default AttendanceForecast;
